import {inject, Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router} from '@angular/router';
import {KeycloakAuthGuard, KeycloakService} from 'keycloak-angular';

import {ToastService} from '../services/toast/toast.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard extends KeycloakAuthGuard {
  private toastService = inject(ToastService);

  constructor() {
    const router = inject(Router);
    const keycloak = inject(KeycloakService);
    super(router, keycloak);
  }

  override async isAccessAllowed(
    route: ActivatedRouteSnapshot,
  ) {
    // Force the user to log in if currently unauthenticated.
    if (!this.authenticated) {
      return false;
    }

    // Get the roles required from the route.
    const requiredRoles = route.data.expectedRoles;

    // Allow the user to proceed if no additional roles are required to access the route.
    if (!(requiredRoles instanceof Array) || requiredRoles.length === 0) {
      return true;
    }

    // Allow the user to proceed if all the required roles are present.
    const hasRequiredRoles = requiredRoles.every((role) => this.roles.includes(role));
    if (!hasRequiredRoles) {
      this.toastService.warning(
        $localize`:@@page-not-authorized-title:Nicht autorisiert`,
        $localize`:@@page-not-authorized-message:Sie haben keine Berechtigung für diese Seite.`,
      );
      return this.router.createUrlTree(['/home']);
    }

    return hasRequiredRoles;
  }
}
